import { PropTypes } from 'mobx-react';
import { SubstitutionProduct } from '../SubstitutionProduct/SubstitutionProduct.jsx';

export const SubstitutionGroup = ({ products }) => (
  <ul className="subst-section__group">
    {products.map((product) => (
      <li key={product.sku.commercialReference}>
        <SubstitutionProduct product={product} />
      </li>
    ))}
  </ul>
);

SubstitutionGroup.propTypes = {
  products: PropTypes.observableArray.isRequired
};
